import axios from 'axios';
import Vue from 'vue'
import Qs from 'qs'
import constants from "@/utils/constants";

// import {uploadExcel} from "./upload";
// import store from "../store";

axios.defaults.timeout = 120000;
axios.defaults.baseURL = '';

console.log("process.env.NODE_ENV", process.env.NODE_ENV);
let domain = "https://beijing-gateway-bside.app-dev.bjev.com.cn/gateway-console/v1/"
if (process.env.NODE_ENV === 'production') {
    //smartservice 域名
    domain = "//beijing-gateway-bside.app-prod.bjev.com.cn/gateway-console/v1/"
    //ack环境 prod域名
    // if (location.origin.indexOf('panel.app-prod.bjev.com.cn') > -1) {
    //     domain = "//console-api.app-prod.bjev.com.cn/gateway-console/v1/"
    // }
}
if (process.env.NODE_ENV === 'pre') {
    domain = "//console-api.inner-app-pre.bjev.com.cn/gateway-console/v1/"
}

function linkLogin() {
    window.location.href = `${constants.VUE_APP_AUTH_URL}/oauth/authorize?response_type=code&client_id=100002&redirect_uri=${window.location.origin}`;
}
  

//http request 拦截器
axios.interceptors.request.use(
    config => {
        // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
        let token = localStorage.token;
        // config.data = JSON.stringify(config.data);
        config.headers = {
            'Content-Type': 'application/json;charset=UTF-8',
        };
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        // if(token){
        //   config.params = {'token':token}
        // }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);


//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.errCode == 2) {
            router.push({
                path: "/login",
                querry: { redirect: router.currentRoute.fullPath }//从哪个页面跳转
            })
        }
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)



/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

function requestAbnormityHandle(that, err) {
    console.log("err", err.request, err.response)
    var statusCode = 0;
    var statusMsg = '';
    if (err.request) {
        statusCode = err.request.status;
        statusMsg = err.request.responseText;
    } else if (err.response) {
        statusCode = err.response.status;
        statusMsg = err.response.data;
    }
    if (statusCode == 401) {
        // that.$message.destroy();
        // that.$message.error('登录已过期');
        localStorage.removeItem("token");
        localStorage.removeItem("uid");
        localStorage.permission = [];
        that.$store.state.permission = [];
        // setTimeout(() => {
        //     window.location.reload()
        // }, 1500)
        linkLogin();
        return

        setTimeout(() => {
            that.$router.push({
                path: '/login'
            })
        }, 1000)
    }
    if (statusCode == 400) {
        that.$message.destroy();
        that.$message.error(statusMsg || '请求失败')
    }
    if (statusCode == 404) {
        that.$message.destroy();
        that.$message.error(statusMsg || '接口不存在')
    }
    if (statusCode == 500) {
        that.$message.destroy();
        that.$message.error(statusMsg || '服务器异常')
    }
}

export function fetch(url, params = {}, responseType) {
    return new Promise((resolve, reject) => {
        var currentDomain = domain;
        if (url.trim().indexOf("http") == 0) {
            currentDomain = ''
        }
        axios.get(currentDomain + url, {
            params: params,
            responseType: responseType || ''
        })
            .then(response => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
                requestAbnormityHandle(this, err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        var currentDomain = domain;
        if (url.trim().indexOf("http") == 0) {
            currentDomain = ''
        }
        axios.post(currentDomain + url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
                requestAbnormityHandle(this, err)
            })
    })
}
// 如果是post 导出
export async function postExport(url, params = {}) {
    var currentDomain = domain;
    if (url.trim().indexOf("http") == 0) {
        currentDomain = ''
    }
    const response = await axios({
        url: currentDomain + url,
        method: 'post',
        responseType: 'blob', 
        data: params
    })
    return response['data'];
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        // this.$message.destroy();
        // console.log(this.$message.loading)
        // const hide = this.$message.loading("提交中", 0);
        axios.put(domain + url, data)
            .then(response => {
                resolve(response.data);
                // setTimeout(hide,0);
            }, err => {
                reject(err);
                requestAbnormityHandle(err);
                // setTimeout(hide,0);
            })
    })
}

export function deletes(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(domain + url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
                requestAbnormityHandle(this, err)
            })
    })
}

export function uploadExcel(url, data) {
    return new Promise((resolve, reject) => {
        var currentDomain = domain;
        if (url.trim().indexOf("http") == 0) {
            currentDomain = ''
        }
        axios.post(currentDomain + url, data, {
            headers: { 'content-type': 'multipart/form-data' }
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
                requestAbnormityHandle(this, err)
            })
    })
}
const postFrom = (url, data, contentType = 'application/x-www-form-urlencoded') => {
    // data =  {
    //   ...data,
    //   _t: Date.parse(new Date())
    // }
    if (contentType == 'application/x-www-form-urlencoded') {
        data = Qs.stringify(data) //query传参
    }
    const service = axios({
        headers: {
            'Content-Type': contentType,
            'Authorization': 'Bearer ' + localStorage.token
        },
        method: 'post',
        url: domain + url,
        data
    }).then((res) => {
        if (parseInt(res.data.data) === 403) {

        } else {
            return res
        }

    })

    return service
}
export function changeParam(param) {
    try {
        let tempArr = [];
        for (let i in param) {
            let key = encodeURIComponent(i);
            let value = encodeURIComponent(param[i]);
            tempArr.push(key + '=' + value);
        }
        let urlParamsStr = tempArr.join('&');
        return '?' + urlParamsStr;
    } catch (err) {
        return '';
    }
}
Vue.prototype.$postFrom = postFrom;
Vue.prototype.$axios = axios;
Vue.prototype.$postExport = postExport;
Vue.prototype.$post = post;
Vue.prototype.$get = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$delete = deletes;
Vue.prototype.$qs = require('qs');
Vue.prototype.$uploadExcel = uploadExcel;
Vue.prototype.$changeParam = changeParam;
Vue.prototype.$baseURL = domain